/**
 * Export Jurisdiction and Classification U.S. EAR99, India Not Subject to Regulations
 */

import React, { createContext, useContext, useState, useEffect, type ReactNode } from 'react';
import { loadTranslations, type Language } from '../../../service/translationService';
import _ from 'lodash';

interface TranslationContextType {
  t: (key: string,params?:Record<string,any>) => string;
  currentLang: Language;
  switchLanguage: (lang: Language) => void;
  loading: boolean;
}



const TranslationContext = createContext<TranslationContextType | undefined>(undefined);

export const TranslationProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [translations, setTranslations] = useState<Record<string, string>>({});
  const [currentLang, setCurrentLang] = useState<Language>('en-us');
  const [loading, setLoading] = useState(true);
  const supportedLangs = ['en-us', 'fr-ca', 'pl'];

  const loadLanguage = async (lang: Language) => {
    setLoading(true);
    const data = await loadTranslations(lang);
    setTranslations(data);
    setCurrentLang(lang);
    setLoading(false);
  };

  const switchLanguage = (lang: Language) => {
     // keep in sync with your service
    const langToUse = supportedLangs.includes(lang) ? lang : 'en-us';
    localStorage.setItem('lang', langToUse);
    loadLanguage(langToUse as Language);
  };



  const getNestedTranslation = (obj: Record<string, any>, key: string,params?:Record<string, any>): string => {
    let value = key ? key.split('.').reduce((acc: any, part) => (acc && acc[part] !== undefined) ? acc[part] : undefined, obj) : "";
    if( typeof value === 'string' && params) {
     Object.entries(params).forEach(([paramKey,paramValue])=>{
      const regex = new RegExp(`{${paramKey}}`,'g');
      value= value.replace(regex,String(paramValue))
     })
    }
    
    return (typeof value === 'string') ? value : key;
  };

  const t = (key: string,params?:Record<string,any>) => getNestedTranslation(translations, key,params);

  useEffect(() => {
    const init = async () => {
      let selectedLanguage: string;
      selectedLanguage = !_.isNil(localStorage.getItem('lang')) ? localStorage.getItem('lang') || 'en-us' : navigator.language || 'en';

      console.log("browser language is  " + selectedLanguage)

      // Normalize to match your available keys, e.g., "en-US" or "fr-FR"
      const langToUse = supportedLangs.includes(selectedLanguage) ? selectedLanguage : 'en-us';
      console.log("using language as " + langToUse)
      await loadLanguage(langToUse as Language);
    };
    init();
  }, []);

  if (loading) {
    return null;
  }

  return (
    <TranslationContext.Provider value={{ t, currentLang, switchLanguage, loading }}>
      {children}
    </TranslationContext.Provider>
  );
};

export const useTranslation = () => {
  const context = useContext(TranslationContext);
  if (!context) {
    throw new Error('useTranslation must be used within a TranslationProvider');
  }
  return context;
};


